import React from 'react';
import TextField from '@material-ui/core/TextField/TextField';
import { withStyles } from '@material-ui/styles';
import styles from '../../assets/jss/NewLoginScreenStyles';
import { CheckIfNotEmpty } from '../../helper/StringUtils';

function CTextField(props) {
  const {
    classes,
    key,
    type,
    name,
    label,
    autoComplete,
    validateForm,
    onChange,
  } = props;

  /** Field is empty or not * */
  const validateInput = (e) => {
    if (validateForm.field === 'count') {
      parseInt(e.target.value) >= 50 ? e.target.classList.remove('warning') : e.target.classList.add('warning');
    } else {
      if (!CheckIfNotEmpty(e.target.value)) {
        e.target.classList.add('warning');
        return false;
      }
      if (name === 'otp') {
        if (e.target.value.length !== 6) {
          e.target.classList.add('warning');
        }
      }
    }
  };

  const removeBorder = (e) => {
    const { removeErr } = props;

    if (validateForm) removeErr(e.target);
  };

  return (
    <React.Fragment key={key}>
      <TextField
        className={`${classes.formInput} ${classes.loginCredentials}`}
        type={type}
        name={name}
        label={label}
        autoComplete={autoComplete || 'off'}
        onBlur={validateForm.check ? validateInput : ''}
        onChange={onChange}
        onClick={removeBorder}
        variant="filled"
      />
    </React.Fragment>
  );
}

CTextField.defaultProps = {
  key: Math.random() * 100,
};

export default withStyles(styles, { withTheme: true })(CTextField);
